import Vue from 'vue';
import Router from 'vue-router';
import { Role } from '@/core/user/roles.js';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/reisetermine/overview',
      component: () => import('@/view/layout/Layout'),
      children: [
        {
          path: '/aufpreis-rechner',
          name: 'aufpreis-rechner',
          component: () => import('@/view/pages/teams/Sales/aufpreis-rechner-view.vue'),
          meta: {
            title: 'Aufpreisrechner',
          },
        },
        {
          path: '/daten-upload',
          name: 'daten-upload',
          component: () => import('@/view/pages/datenUpload/daten-upload-view.vue'),
          meta: { authorize: [Role.ADMIN, Role.IMPORT], title: 'Daten-Upload' },
        },
        {
          path: '/umfragen',
          name: 'umfragen',
          component: () => import('@/view/pages/umfragen/umfragen.vue'),
          meta: { authorize: [Role.ADMIN], title: 'Umfragen' },
        },
        {
          path: '/aufgaben',
          name: 'aufgaben',
          component: () => import('@/view/pages/aufgaben/aufgaben.vue'),
          children: [
            {
              path: 'overview',
              name: 'aufgaben-overview',
              component: () => import('@/view/pages/aufgaben/aufgaben-overview.vue'),
              meta: {
                title: 'Aufgabenübersicht',
              },
            },
          ],
        },
        {
          path: '/yield',
          name: 'yield',
          component: () => import('@/view/pages/teams/yield/yield.vue'),
          meta: { authorize: [Role.ADMIN, Role.YIELD] },
          children: [],
        },
        {
          path: '/wbscgi',
          name: 'csv-query',
          component: () => import('@/view/pages/blank/flugverfuegbarkeits-query.vue'),
          meta: { title: 'Flugverfügbarkeit' },
        },
        {
          path: '/reisen',
          name: 'reisen',
          component: () => import('@/view/pages/reisen/reisen.vue'),
          children: [
            {
              path: 'prioritaeten',
              name: 'reisen-prioritaeten',
              component: () => import('@/view/pages/teams/Sales/prioritaeten-view.vue'),
              meta: { title: 'Prioritäten' },
            },
            {
              path: 'overview',
              name: 'reisen-overview',
              component: () => import('@/view/pages/reisen/reisen-overview.vue'),
              meta: { title: 'Reiseübersicht' },
            },
            {
              path: ':reisekuerzel',
              component: () => import('@/view/pages/reisen/reisen-view.vue'),
              props: true,
              children: [
                {
                  path: 'edit',
                  name: 'reisen-edit-view',
                  component: () => import('@/view/pages/reisen/reisen-edit-view.vue'),
                  meta: { title: 'Reisen bearbeiten' },
                  props: true,
                },
                {
                  path: 'reisestammdaten',
                  name: 'reisen-reisestammdaten-view',
                  component: () => import('@/view/pages/reisen/reisen-metadata-view.vue'),
                  meta: {
                    title: 'Reisestammdaten bearbeiten',
                    authorize: [Role.ADMIN, Role.PM, Role.YIELD],
                  },
                  props: true,
                },
                {
                  path: 'th-vk-max',
                  name: 'reisen-saisonpreise-view',
                  component: () => import('@/view/pages/reisen/reisen-saisonpreise-view.vue'),
                  meta: { title: 'TH / VK Max bearbeiten', authorize: [Role.ADMIN, Role.PM] },
                  props: true,
                },
                {
                  path: 'passdatenkonfiguration',
                  name: 'reisen-edit-passdatenkonfiguration-view',
                  component: () => import('@/view/pages/reisen/reisen-edit-passdatenkonfiguration-view.vue'),
                  meta: { title: 'Reiseterminpassdaten-Konfiguration' },
                  props: true,
                },
              ],
            },
          ],
        },
        {
          path: '/reisetermine',
          name: 'reisetermine',
          component: () => import('@/view/pages/reisetermine/reisetermine.vue'),
          children: [
            {
              path: 'fvc/overview',
              name: 'fvc-overview',
              component: () => import('@/view/pages/teams/yield/fvc-overview.vue'),
              meta: {
                title: 'FVC-Übersicht',
                authorize: [Role.ADMIN, Role.YIELD],
              },
            },
            {
              path: 'fvc/rm-reisebasis',
              component: () => import('@/view/pages/teams/yield/rm-reisebasis.vue'),
              meta: {
                title: 'RM Reisebasis',
                authorize: [Role.ADMIN, Role.YIELD],
              },
            },
            {
              path: 'fvc/rm-historie',
              component: () => import('@/view/pages/teams/yield/rm-historie.vue'),
              meta: {
                title: 'RM Historie',
                authorize: [Role.ADMIN, Role.YIELD],
              },
            },
            {
              path: 'fvc/kpi-dashboard',
              component: () => import('@/view/pages/teams/yield/kpi-dashboard.vue'),
              meta: {
                title: 'KPI Dashboard',
                authorize: [Role.ADMIN, Role.YIELD],
              },
            },
            {
              path: 'fvc/kpi-leading',
              component: () => import('@/view/pages/teams/yield/leading-kpis.vue'),
              meta: {
                title: 'Leading KPIs',
                authorize: [Role.ADMIN, Role.YIELD],
              },
            },
            {
              path: 'fvc/kpi-historie',
              component: () => import('@/view/pages/teams/yield/kpi-historie.vue'),
              meta: {
                title: 'KPI Historie',
                authorize: [Role.ADMIN, Role.YIELD],
              },
            },
            {
              path: 'zvc',
              name: 'zvc',
              component: () => import('@/view/pages/reisetermine/zvc-view.vue'),
              meta: {
                title: 'Zimmerverfügbarkeitscontrolling',
                authorize: [Role.ADMIN, Role.PM, Role.YIELD, Role.DOM, Role.CSM],
              },
            },
            {
              path: 'yield-controlling',
              name: 'yield-controlling',
              component: () => import('@/view/pages/teams/yield-controlling/yield-controlling-overview.vue'),
              meta: {
                title: 'Yield Controlling',
                authorize: [Role.ADMIN, Role.YIELD],
              },
            },
            {
              path: 'reisefinder',
              name: 'reisetermin-reisefinder',
              component: () => import('@/view/pages/teams/Sales/reisefinder-view.vue'),
              meta: { title: 'Reisefinder' },
            },
            {
              path: 'planung',
              name: 'pm-planung',
              component: () => import('@/view/pages/teams/PM/terminplanung-view.vue'),
              meta: {
                title: 'Reiseterminplanung',
                authorize: [Role.ADMIN, Role.YIELD, Role.PM, Role.AM],
              },
            },
            {
              path: 'kontrollansicht-daten',
              name: 'reseitermine-kontrollansicht-daten',
              component: () => import('@/view/pages/reisetermine/kontrollansicht-daten-view.vue'),
              meta: { title: 'Kontrollansicht-Daten', authorize: [Role.ADMIN, Role.PM] },
            },
            {
              path: 'flugplanung',
              name: 'flugplanung-planung',
              component: () => import('@/view/pages/reisetermine/flugplanung-overview.vue'),
              meta: { title: 'Flugplanung', authorize: [Role.ADMIN, Role.YIELD, Role.PM] },
            },
            {
              path: 'touristische-planung',
              name: 'touristische-planung',
              component: () => import('@/view/pages/touristische-planung/touristische-planung-overview.vue'),
              meta: {
                title: 'Touristische Planung',
                authorize: [Role.ADMIN, Role.CONTROLLING],
              },
            },
            {
              path: 'transferplanung',
              name: 'transferplanung',
              component: () => import('@/view/pages/reisetermine/transferplanung-view.vue'),
              meta: { title: 'Transferplanung', authorize: [Role.ADMIN, Role.PM] },
            },
            {
              path: 'overview',
              name: 'reisetermine-overview',
              component: () => import('@/view/pages/reisetermine/reisetermine-overview.vue'),
              meta: { title: 'Reiseterminübersicht' },
            },
            {
              path: ':reiseterminId',
              component: () => import('@/view/pages/reisetermine/reisetermin-view-navigation.vue'),
              props(route) {
                const props = { ...route.params };
                props.reiseterminId = parseInt(props.reiseterminId);
                return props;
              },
              children: [
                {
                  path: '',
                  name: 'reisetermine-view',
                  component: () => import('@/view/pages/reisetermine/reisetermin-view-tab-default.vue'),
                  meta: { title: 'Reisetermindetails' },
                },
                {
                  path: 'releasepruefung',
                  name: 'reisetermin-view-releasepruefung',
                  component: () =>
                    import('@/view/pages/reisetermine/reisetermin-view-tab-releasepruefung.vue'),
                  meta: {
                    title: 'Reisetermin-Releaseprüfung',
                    authorize: [Role.ADMIN, Role.DOM, Role.CSM],
                  },
                },
              ],
            },
          ],
        },
        {
          path: 'airlines',
          name: 'airline-view',
          component: () => import('@/view/pages/airline/airline-view.vue'),
          meta: {
            title: 'Airline bearbeiten',
            authorize: [Role.ADMIN, Role.YIELD, Role.PM],
          },
          props: true,
        },
        {
          path: 'flugstammdaten',
          name: 'flugstammdaten-view',
          component: () => import('@/view/pages/stammdaten/flugstammdaten-view.vue'),
          meta: { title: 'Flugstammdaten', authorize: [Role.ADMIN, Role.AM] },
        },
        {
          path: 'restriktionen',
          name: 'restriktionen',
          component: () => import('@/view/pages/restriktionen/restriktionen-overview.vue'),
          meta: { title: 'Restriktionen', authorize: [Role.ADMIN, Role.PM, Role.YIELD] },
        },
        {
          path: '/OM',
          name: 'OM',
          component: () => import('@/view/pages/teams/OM/om-view.vue'),
          meta: { title: 'Office Management' },
          children: [
            {
              path: '/kunden',
              name: 'kunden',
              component: () => import('@/view/pages/kunden/kunden.vue'),
              children: [
                {
                  path: 'confirmation',
                  name: 'dubletten-confirmation',
                  component: () => import('@/view/pages/kunden/kunden-dubletten-confirmation-view.vue'),
                  meta: { authorize: [Role.ADMIN, Role.OM], title: 'Kunden-Dublettenprüfung' },
                },
              ],
            },
            {
              path: '/agenturen',
              name: 'agenturen',
              component: () => import('@/view/pages/agenturen/agenturen.vue'),
              children: [
                {
                  path: 'confirmation',
                  name: 'agenturen-dubletten-confirmation',
                  component: () => import('@/view/pages/agenturen/agenturen-dubletten-confirmation-view.vue'),
                  meta: {
                    authorize: [Role.ADMIN, Role.OM],
                    title: 'Agenturen-Dublettenprüfung',
                  },
                },
              ],
            },
          ],
        },
        {
          path: '/vorgaenge',
          name: 'vorgaenge',
          component: () => import('@/view/pages/vorgaenge/vorgaenge.vue'),
          children: [
            {
              path: 'overview',
              name: 'flugbuchungen-controlling',
              component: () => import('@/view/pages/vorgaenge/flugbuchungen-controlling-view.vue'),
              meta: { authorize: [Role.ADMIN, Role.FOM, Role.SALES], title: 'Flugbuchungen Controlling' },
            },
            {
              path: 'rechnungspruefung/katalog-reisen',
              name: 'katalog-reisen',
              component: () => import('@/view/pages/vorgaenge/rechnungspruefung/katalog-reisen-view.vue'),
              meta: { authorize: [Role.ADMIN, Role.BUCHHALTUNG], title: 'Katalog Reisen' },
            },
            {
              path: 'rechnungspruefung/fit-reisen',
              name: 'fit-reisen',
              component: () => import('@/view/pages/vorgaenge/rechnungspruefung/fit-reisen-view.vue'),
              meta: { authorize: [Role.ADMIN, Role.BUCHHALTUNG], title: 'FIT Reisen' },
            },
            {
              path: 'rechnungspruefung/zahllaeufe',
              name: 'zahllaeufe',
              component: () => import('@/view/pages/vorgaenge/rechnungspruefung/zahllaeufe-view.vue'),
              meta: { authorize: [Role.ADMIN, Role.BUCHHALTUNG], title: 'Zahlläufe' },
            },
          ],
        },
      ],
    },
    {
      path: '/code=*',
      name: 'code',
      redirect: { path: '/reisetermine/overview' },
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/view/pages/auth/auth.vue'),
    },
    {
      path: '/not-authorized',
      name: 'not-authorized',
      props: true,
      component: () => import('@/view/pages/auth/not-authorized.vue'),
    },
    {
      path: '/restricted',
      name: 'restricted',
      meta: {
        authorize: ['nobody'],
      },
      component: () => import('@/view/pages/auth/not-authorized.vue'),
    },
    {
      path: '*',
      redirect: '/404',
    },
    {
      // the 404 route, when none of the above matches
      path: '/404',
      name: '404',
      component: () => import('@/view/pages/error/Error-1.vue'),
      meta: { title: 'SKR Manager | Fehler :(' },
    },
    {
      path: '/403',
      name: '403',
      component: () => import('@/view/pages/error/Error-403.vue'),
      meta: { title: 'SKR Manager | Fehler :(' },
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      // on popstate events (forwards, backwards) jump to previous position
      return savedPosition;
    } else if (to.hash) {
      // if hash is set get the corresponding element and try to scroll to it
      const element = document.querySelector(to.hash);
      if (element) {
        window.scrollTo({
          top: element.offsetTop,
          behavior: 'smooth',
        });
      } else {
        // element not found -> return selector
        return { selector: to.hash };
      }
    } else {
      //no hash or history found scroll to top
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  },
});
